/**
 * Cross-module registry of media elements keyed by layer id. Lets the
 * AudioReconciler pick a master clock (audio or video) without depending on
 * the Konva renderer module.
 */
const elements = new Map<string, HTMLMediaElement>();

export const mediaRegistry = {
  set(layerId: string, el: HTMLMediaElement): void {
    elements.set(layerId, el);
  },
  delete(layerId: string): void {
    elements.delete(layerId);
  },
  get(layerId: string): HTMLMediaElement | undefined {
    return elements.get(layerId);
  },
};
